"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { ColorPaletteId } from "@/lib/theme/color-palettes";

interface InitialPersonalization {
  colorPalette: ColorPaletteId;
  customColor: string | null;
  grainEnabled: boolean;
}

const InitialPersonalizationContext = createContext<InitialPersonalization | null | undefined>(undefined);

export const InitialPersonalizationProvider = ({
  children,
  value,
}: {
  children: ReactNode;
  value: InitialPersonalization | null | undefined;
}) => {
  return (
    <InitialPersonalizationContext.Provider value={value}>
      {children}
    </InitialPersonalizationContext.Provider>
  );
};

export const useInitialPersonalization = () => {
  // useContext returns undefined (default value) if called outside of provider
  // This allows DashboardThemeProvider to work on both public and dashboard pages
  return useContext(InitialPersonalizationContext);
};

